export default function Contact() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Contact Us</h2>
 <p>Name: Kumail Hasan</p>
<p>Business Name: Nawabi Bites</p>
      <p>📍 Address: 450/631 Kalay Ki gali.Muftiganj,Sangam Stationary,Lucknow,U.P,India</p>
      <p>📞 Phone: +91-7355470907</p>
 <p>📩 Email: kumailh553@gmail.com</p>
 <p>⏰ Customer Support: 10 AM – 6 PM (All Days)</p> 
    </div>
  );
}
